export default {
	methods: {
		/** @returns {string} */
		getRegionId: function () {
			if (process.env.MIX_REGION_ID) {
				return process.env.MIX_REGION_ID.toLowerCase();
			}

			return 'gb';
		},

        getRegionUrlSegment(){
            let regionSegment = (typeof this.$route.query.lang === 'undefined') ? 'gb' : this.$route.query.lang;
            let region = this.getRegionId();

            if (region == 'us' && regionSegment != 'de') {
                regionSegment = region;
            }

            return regionSegment;
        }
	}
}